import React, { useState, useEffect, useRef, useContext } from "react";
import { RingLoader } from "react-spinners";
import * as Yup from "yup";
import SatelliteMap from "../../Components/SatelliteMap/SatelliteMap";
import Select from "react-select";
import { Steps, Modal } from "antd";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Axios from "../../Helpers/Interceptors";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
// Sample data: Request type, estimated vs actual resolution times (in hours)
import "./TicketDetail.scss";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import { UserInfo } from "../../Context/userInfo";
import genAiLogo from "../../assests/genai_logo.png";
import { getRole } from "../../Helpers/utils";
import image from "../../assests/Screenshot 2025-03-07 181628.png";
import image1 from "../../assests/MAII_Backgrounds_hexagonal-wave.webp";
const containerStyle = {
  width: "100%",
  height: "15rem",
};

const formatDateUS = (date) => {
  return new Date(date).toLocaleDateString("en-US");
};
export default function TicketDetail() {
  const [stepStatus, setstepStatus] = useState("Reported");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [steps, setSteps] = useState([
    { title: "Reported" },
    { title: "In Progress" },
    { title: "Assign To DPT" },
    { title: "Resolved" },
  ]);
  const [loading, setLoading] = useState(true);
  const [agentList, setAgentList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [confirmLogsModal, setconfirmLogsModal] = useState(false);

  const extractInteger = (percentageStr) => {
    const number = parseFloat(percentageStr); // Convert string to number
    return Math.floor(number); // Return integer part
  };

  const navigate = useNavigate();
  const [streetViewVisible, setStreetViewVisible] = useState(false);
  const [initialValues, setInitialValues] = useState({
    request_type: "",
    request_subtype: "",
    name: "",
    contact_phone: "",
    contactEmail: "",
    status: "",
    priority: "",
    description: "",
    ticketNumber: "",
    agentId: "",
    departmentId: "",
    comment: "",
    aiAnalysis: "",
    aiPredictedTime:"",
    aiImageAnalysis:"",
    lat:39.5,
    lng:-98.35
  });

  const validationSchema = Yup.object().shape({
    request_type: Yup.string(),
    //   .required("Role is required *"),
    request_subtype: Yup.string(),
    //   .required("Role is required *"),
    name: Yup.string(),
    // .required("Role is required *"),
    contact_phone: Yup.string(),
    //   .required("Role is required *"),
    contactEmail: Yup.string(),
    //   .required("Role is required *"),
    status: Yup.string(),
    //   .required("Role is required *"),
    priority: Yup.string(),
    //   .required("Role is required *"),
    description: Yup.string(),
    //   .required("Role is required *"),
    ticketNumber: Yup.string(),
    //   .required("Role is required *"),
  });
  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const { id } = useParams();
  const [data, setData] = useState({});
  const [logList, setLoglist] = useState([]);

  const [center, setcenter] = useState({ lat: 39.5, lng: -98.35 });

  const { userData, updateUserData } = useContext(UserInfo);
  const [roles, setRoles] = useState(null);



const getRoundOfValue = ( data) =>{
  const value = data;
  const newValue = value.toString();
  if(!newValue.includes('.')){
      return "Could not be performed accurately."
  }else{
    const number =  Number(newValue.slice(0,6))
    return Math.round(number)
  }

  // For rounding to 5, you could just set:

}


  useEffect(() => {
    if (userData) {
      setRoles(getRole(userData.data?.userInfo?.roles));
    }
  }, [userData]);

  useEffect(() => {
    getAgents();
    getDepartments();
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/status-history/ticketnumber/${id}`
      );

      console.log(response.data);

      setData(response.data.incident);

      const enrichedSteps = steps.map((step) => {
        const match = response.data.statusHistories.find(
          (item) => item.status === step.title
        );
        return {
          ...step,
          description: match ? formatDateUS(match.createdAt) : null,
        };
      });

      setSteps(enrichedSteps);
      console.log(enrichedSteps);



      let data = response.data.incident;
      let lat= data["location"]["coordinates"][1];
      let lng= data["location"]["coordinates"][0];
      console.log(lat,lng);
      setcenter({
        lat,
        lng
      }); // Approximate center of the U.S.

      setInitialValues({
        request_type: data.request_type,
        request_subtype: data.request_subtype,
        name: data.reporter.name,
        contact_phone: data.reporter.contact_phone,
        contactEmail: data.reporter.contactEmail,
        status: data.status == "Request Created" ? "Reported" : data.status,
        priority: data.priority,
        description: data.description,
        ticketNumber: data.ticketNumber,
        address: data.location.address,
        agentId: data.agentId,
        departmentId: data.departmentId,
        aiAnalysis: data?.aiAnalysis || null,
        aiPredictedTime:data?.aiPredictedTime || null,
        aiImageAnalysis: data?.aiImageAnalysis?.results || [],
        lat: lat ? lat : 39.5,
        lng: lng ? lng : -98.35
      });
      setstepStatus(
        data.status == "Request Created" ? "Reported" : data.status
      ); // Dynamic value from your state or API

      // fetchMuitiQuery(data);

      // fetchPredictImage(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    } finally {
      setLoading(false);
      console.log(false);
    }
  };

  const getAgents = async () => {
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/agents/agents-list`
      );
      console.log("jj", response.data);

      setAgentList(response.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  const getDepartments = async () => {
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/departments/departments-list`
      );

      setDepartmentList(response.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  // const [multiQuery, setmultiQuery] = useState();
  const [multiClass, setmultiClass] = useState([]);

  async function convertImageToBase64(imageUrl) {
    const response = await fetch(imageUrl);
    const arrayBuffer = await response.arrayBuffer();
    const base64String = btoa(
      String.fromCharCode(...new Uint8Array(arrayBuffer))
    );
    console.log(base64String);
    return base64String;
  }

  // const fetchMuitiQuery = async (data) => {
  //   try {
  //     const response = await Axios.post(`https://smartml.tscti.com/classify/`, {
  //       text: data.request_type,
  //     });
  //     console.log(response.data);
  //     setmultiQuery(response.data);
  //   } catch (err) {
  //     console.log(err.message);
  //   } finally {
  //     console.log(false);
  //   }
  // };

  // const [predict, setpredict] = useState([]);

  // const fetchPredictImage = async (data) => {
  //   const urlArray = data.attachment.map((item) => item.url);

  //   try {
  //     const response = await Axios.post(
  //       `https://smartml.tscti.com/classify_image/`,
  //       { image_paths: urlArray }
  //     );

  //     setpredict(response.data.results);
  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false);
  //     toast.error(err.message);
  //     console.log(err.message);
  //   } finally {
  //     setLoading(false);
  //     console.log(false);
  //   }
  // };

  const submit = async (value, reset) => {
    try {
      const obj = {
        ...value,

      };
      if(value.comment){
        obj.comment = [
          {
            description: value.comment,
            author: roles,
          },
        ]
      }
      const response = await Axios.put(
        `https://demo.tscti.com/api/incident/${data.id}`,
        obj
      );

      if (response.status == 200) {
        // Checks if status code is 200 (OK)
        toast.success("Status change successfully");
        reset();
        setInitialValues(prev => ({ ...prev, comment: "" }));
        fetchData();
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };
  const currentStepIndex = steps.findIndex((step) => step.title === stepStatus);

  const [isDivVisible, setIsDivVisible] = useState(false);

  const generatePDF = () => {
    // Toggle the div visibility to show it for PDF generation
    setIsDivVisible(true);

    // Get the HTML content of the div with id 'download-template'
    const content = document.getElementById("download-template");

    // Use html2pdf.js to generate the PDF from HTML content
    const options = {
      margin: 1,
      filename: "ticket-details.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a3", orientation: "portrait", fontSize: 5 },
    };

    // Generate PDF
    html2pdf()
      .from(content) // Pass the content you want to convert to PDF
      .set(options)
      .save() // Automatically download the PDF
      .finally(() => {
        // Hide the div after PDF generation
        setIsDivVisible(false);
      });
  };

  const confirmToggle = async (values) => {
    console.log(values);
    try {
      const obj = {
        ticketId: data?.id,

      };
      const agent =  agentList.filter((res)=> res.agentId == values.agentId)
      if (roles == "Admin") {
        obj.agentId = values?.agentId;
        obj.agentEmail = agent[0].agentUserName
        const response = await Axios.post(
          `https://demo.tscti.com/api/agents/assign-ticket`,
          obj
        );
        if (response.status == 200) {
          // Checks if status code is 200 (OK)

          toast.success("Status change successfully");
          getAgents();
          getDepartments();
          fetchData();

          setConfirmModalOpen(false);
        }
      } else {
        obj.departmentId = values?.departmentId;

        const response1 = await Axios.post(
          `https://demo.tscti.com/api/departments/assign-ticket`,
          obj
        );
        if (response1.status == 200) {
          // Checks if status code is 200 (OK)

          toast.success("Status change successfully");
          getAgents();
          getDepartments();
          fetchData();

          setConfirmModalOpen(false);
        }
      }
      console.log(obj);
    } catch (err) {
      console.log(err);
    } finally {
      console.log(false);
    }
  };

  const cancelToggle = (setfield) => {
    if (roles == "Admin") {
      setfield("agentId", data.agentId);
      setConfirmModalOpen(false);
    } else {
      setfield("departmentId", data.departmentId);
      setConfirmModalOpen(false);
    }
  };

  const handleDropdownChange = () => {
    setConfirmModalOpen(true);
  };

  const cancelToggleLogs = () => {
    // setUserToToggle(null);
    setconfirmLogsModal(false);
    // getUser(userData?.id); // Close the confirmation modal without any changes
  };

  return (
    <>
      <div className="container-fluid">
        {/* <div
          className="card  card-margin  p-2"
          style={{
            background: "rgb(130 195 65 / 69%)",
            textAlign: "center",
          }}
        >
          <h5 style={{ color: "whitesmoke" }}>
            {" "}
            311 Service Ticket No #{data.ticketNumber}
          </h5>
        </div> */}

        <div className="row">
          <div className="col-md-12">
            <div className="card card-size1 status-card">
              <div className="heading-content p-1">
                <h5>
                  Ticket Status
                  <span
                    style={{
                      marginLeft: "8px",
                      backgroundColor: "#1890ff",
                      color: "#fff",
                      padding: "4px 10px",
                      borderRadius: "12px",
                      fontWeight: "500",
                      fontSize: "0.95rem",
                    }}
                  >
                    {data.ticketNumber}
                  </span>
                </h5>
              </div>
              <div style={{ textAlign: "right" }}>
                <button
                  className="btn  btn-save"
                  onClick={generatePDF}
                  style={{
                    background: "rgb(130 195 65 / 69%)",
                    color: "whitesmoke",
                  }}
                >
                  <i className="fas fa-download"></i>{" "}
                </button>
              </div>

              <div style={{ padding: "1rem 9rem 3rem 9rem" }}>
                <Steps
                  current={currentStepIndex}
                  items={steps.map((step, index) => ({
                    ...step,
                    status:
                      index < currentStepIndex
                        ? "finish" // Completed steps
                        : index === currentStepIndex
                        ? currentStepIndex === steps.length - 1
                          ? "finish" // Last step should be "finish" instead of "process"
                          : "process" // Current step in progress
                        : "wait", // Future steps
                  }))}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-lg-6">
            <div
              className="card card-size"
              style={{ background: "rgb(31, 41, 53)" }}
            >
              <Formik
                // validationSchema={validationSchema}
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={(values, { resetForm }) => {
                  submit(values, resetForm); // Use your custom submit logic here
                }}
              >
                {({ errors, touched, setFieldValue, values }) => (
                  <Form id="signup-form" className="signup-form">
                    <div className="row">
                      <div className="heading-content p-1">
                        <h5>Tickets Detail</h5>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">Ticket Number</label>
                        <Field
                          className={`form-input ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="ticketNumber"
                          id="ticketNumber"
                          placeholder="Ticket Number*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">Ticket Type</label>
                        <Field
                          className={`form-input ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="request_type"
                          id="request_type"
                          placeholder="Ticket Type*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">
                          Ticket Sub Type
                        </label>
                        <Field
                          className={`form-input ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="request_subtype"
                          id="request_subtype"
                          placeholder="Ticket Sub Type*"
                          autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">Priority</label>
                        <Field
                          className={`form-input ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="priority"
                          id="priority"
                          placeholder="Priority*"
                          autoComplete="new-password"
                        />
                      </div>
                      {roles == "Admin" && (
                        <div className="col-md-4 col-lg-4">
                          <label className="label-heading1">
                            Assign To Agent
                          </label>
                          <Field name="agentId">
                            {({ form }) => {
                              const selectedValue = agentList.find(
                                (option) =>
                                  option.agentId === form.values.agentId
                              );

                              return (
                                <Select
                                  value={
                                    selectedValue
                                      ? {
                                          value: selectedValue.agentId,
                                          label: selectedValue.agentUserName,
                                        }
                                      : null
                                  }
                                  options={agentList.map((res) => ({
                                    value: res.agentId,
                                    label: res.agentUserName,
                                  }))}
                                  isSearchable
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      width: "100%",
                                      height: 48,

                                      background: "#15212d",
                                      borderColor: "rgb(223, 223, 223)",
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      color: 'black',
                                      backgroundColor: 'white', // dropdown background
                                    }),
                                    option: (base, state) => ({
                                      ...base,
                                      color: 'black',
                                      backgroundColor: state.isFocused ? '#eaeaea' : 'white', // optional hover color
                                    }),
                                    singleValue: (base) => ({
                                      ...base,
                                      color: 'white',
                                    }),
                                  }}

                                  onChange={(selectedOption) => {
                                    handleDropdownChange();

                                    form.setFieldValue(
                                      "agentId",
                                      selectedOption?.value || ""
                                    );
                                  }}
                                />
                              );
                            }}
                          </Field>
                        </div>
                      )}
                      {roles == "Agent" && (
                        <div className="col-md-4 col-lg-4">
                          <label className="label-heading1">
                            Assign to Department
                          </label>
                          <Field name="departmentId">
                            {({ form }) => {
                              const options = departmentList.map((res) => ({
                                value: res.agentId,
                                label: res.agentUserName,
                              }));

                              const selectedValue = options.find(
                                (d) => d.value === form.values.departmentId
                              );

                              return (
                                <Select
                                  value={selectedValue || null}
                                  options={options}
                                  isSearchable

                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      width: "100%",
                                      height: 48,

                                      background: "#15212d",
                                      borderColor: "rgb(223, 223, 223)",
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      color: 'black',
                                      backgroundColor: 'white', // dropdown background
                                    }),
                                    option: (base, state) => ({
                                      ...base,
                                      color: 'black',
                                      backgroundColor: state.isFocused ? '#eaeaea' : 'white', // optional hover color
                                    }),
                                    singleValue: (base) => ({
                                      ...base,
                                      color: 'white',
                                    }),
                                  }}
                                  onChange={(selectedOption) => {
                                    handleDropdownChange();
                                    form.setFieldValue(
                                      "departmentId",
                                      selectedOption?.value || ""
                                    );
                                  }}
                                />
                              );
                            }}
                          </Field>
                        </div>
                      )}
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">Status</label>
                        <Field name="status">
                          {({ form }) => {
                            const options = [
                              { value: "Reported", label: "Reported" },
                              { value: "In Progress", label: "In Progress" },
                              {
                                value: "Assign To DPT",
                                label: "Assign to DPT",
                              },
                              { value: "Resolved", label: "Resolved" },
                            ];

                            const selectedValue = options.find(
                              (opt) => opt.value === form.values.status
                            );

                            return (
                              <Select
                                value={selectedValue || null}
                                options={options}
                                isSearchable
                                isDisabled={true}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    width: "100%",
                                    height: 48,

                                    background: "#15212d",
                                    borderColor: "rgb(223, 223, 223)",
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    color: 'black',
                                    backgroundColor: 'white', // dropdown background
                                  }),
                                  option: (base, state) => ({
                                    ...base,
                                    color: 'black',
                                    backgroundColor: state.isFocused ? '#eaeaea' : 'white', // optional hover color
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color: 'white',
                                  }),
                                }}
                                onChange={(selectedOption) => {
                                  form.setFieldValue(
                                    "status",
                                    selectedOption?.value || ""
                                  );
                                }}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="heading-content p-1">
                        <h5>Reporter Details</h5>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">Name</label>
                        <Field
                          className={`form-input ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="name"
                          id="name"
                          placeholder="Name*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">Phone No</label>
                        <Field
                          className={`form-input ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="contact_phone"
                          id="contact_phone"
                          placeholder="Phone No*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading1">Contact Email</label>
                        <Field
                          className={`form-input ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="contactEmail"
                          id="contactEmail"
                          placeholder="Email*"
                          autoComplete="new-password"
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="form-group">
                        <div className="col-md-6 col-lg-6">
                          <label className="label-heading1">Description</label>
                          <Field
                            as="textarea"
                            className={`form-input ${
                              errors.email && touched.email ? "error" : ""
                            }`}
                            name="description"
                            id="description"
                            placeholder="Description*"
                            autoComplete="new-password"
                            rows="4"
                            cols="12"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="form-group">
                        <div className="col-md-12 col-lg-12">
                          <label className="label-heading1">Comment</label>
                          <Field
                            as="textarea"
                            className={"form-input"}
                            name="comment"
                            id="comment"
                            placeholder="Comment*"
                            autoComplete="new-password"
                            rows="4"
                            cols="20"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    >
                      <button
                        className="btn btn-style  btn-primary"
                        onClick={() => setconfirmLogsModal(true)}
                       type="button"
                      >
                        <i
                          className="bx bx-show"
                          style={{ marginRight: "8px" }}
                        ></i>{" "}
                        View Logs
                      </button>
                      <button
                  type="submit"
                        className="btn btn-style  btn-save"
                        style={{
                          background: "rgb(130 195 65 / 69%)",
                          color: "whitesmoke",
                        }}
                      >
                        <i
                          className="fas fa-save"
                          style={{ marginRight: "8px" }}
                        ></i>{" "}
                        Save
                      </button>

                      <button
                        className="btn btn-style  btn-cancel"
                        onClick={() => navigate("/dashboard")}
                        style={{ background: "#F44336", color: "whitesmoke" }}
                      >
                        <i
                          className="fas fa-times"
                          style={{ marginRight: "8px" }}
                        ></i>{" "}
                        Cancel
                      </button>
                    </div>

                    <Modal
                      open={confirmModalOpen}
                      onCancel={() => cancelToggle(setFieldValue)}
                      destroyOnClose={true}
                      footer={null}
                      maskClosable={false}
                    >
                      <div className="signup-content-model1">
                        <p style={{color:'black'}}>
                          Are you sure you want to Assign this{" "}
                          {roles == "Admin" ? "Agent " : "Department"} ?
                        </p>
                        <div
                          className="submit-container1"
                          style={{ marginTop: "20px" }}
                        >
                          <button
                            className="submit-button1 "
                            type="submit"
                            onClick={() => confirmToggle(values)}
                          >
                            Yes
                          </button>
                          <button
                            className="submit-button2"
                            type="button"
                            onClick={() => cancelToggle(setFieldValue)}
                          >
                            No
                          </button>
                        </div>
                      </div>
                    </Modal>
                  </Form>
                )}
              </Formik>
            </div>
            {
              <div className="attachment1 p-3" style={{ background: "rgb(31, 41, 53)" }}>
              { initialValues.lat && initialValues.lng && (
                <SatelliteMap lat={initialValues.lat} lng={initialValues.lng} />
                )}
            </div>
            }
          </div>
          <div className="col-md-6 col-lg-6">
            <div
              className="card card-size logs-box"
              style={{
                background: "rgb(31, 41, 53)",
                backgroundImage: `url(${image})`,
              }}
            >
              {" "}
              <div
                style={{ height: "4rem" }}
                className="heading-content p-2 d-flex  justify-content-between rounded-xl shadow-md bg-gradient-to-r from-[#0f0c29] via-[#302b63] to-[#24243e]"
              >
                <div className="text-white d-flex flex-column justify-content-start ">
                  <label className="text-base font-semibold tracking-wide mt-3" style={{ color: "rgb(15, 255, 193)"}}>
                    AI Request Prediction
                  </label>
                  <p className="text-xs text-gray-300 mt-0.5 " style={{ color: "rgb(15, 255, 193)"}}>
                    Classify and route requests with AI
                  </p>
                </div>
                <img
                  src={genAiLogo}
                  alt="Powered by Gen AI Logo"
                  className="rounded shadow object-contain me-2"
                  style={{
                    height: "45px",
                    width: "auto",
                    filter: "drop-shadow(0 0 6px #0fffc1)",
                  }}
                />
              </div>
              <div className="text-light">
              <div className="text-light d-flex" style={{ width: "100%" }}>
  <div
    className="border border-white p-3 rounded shadow-sm"
    style={{ fontSize: "16px", width: "60%" }}
  >
    <p style={{ fontSize: "14px" }}>
      <i className="fa-solid fa-comment-dots me-2"></i>
      <b style={{ color: "rgb(15, 255, 193)"}}>Request Type : </b> <br />
      {initialValues?.aiAnalysis?.request_type
        ? capitalizeFirstLetter(initialValues?.aiAnalysis?.request_type)
        : "No request type available"}
    </p>

    <span style={{ width: "100%" }}>
      <progress
        id="file"
        value={parseFloat(initialValues?.aiAnalysis?.confidence_percentage)}
        max="100"
        style={{ width: "100%", height: "20px" , appearance: 'none', }}
      >
        {initialValues?.aiAnalysis?.confidence_percentage}
      </progress>
      <div className="d-flex align-items-center">
        <label>Prediction Accuracy:</label>
        <strong className="fs-2 ms-2 text-end">
          {initialValues?.aiAnalysis?.confidence_percentage} %
        </strong>
      </div>
    </span>
  </div>

  <div
    className="border border-white ms-1 p-3 rounded shadow-sm"
    style={{ fontSize: "16px", width: "40%" }}
  >
    <p style={{ fontSize: "14px" }}>
      <i className="fa fa-list-alt" style={{ fontSize: "12px" }}></i>
      <b style={{ marginLeft: "6px" , color: "rgb(15, 255, 193)"}}>Request Reason :</b>
      <br />
      {initialValues?.aiAnalysis?.request_type
        ? capitalizeFirstLetter(initialValues?.aiAnalysis?.request_reason)
        : "No request reason available"}
    </p>

    <p style={{ fontSize: "14px" }}>
      <i className="fa-solid fa-building"></i>
      <b style={{ marginLeft: "4px", color: "rgb(15, 255, 193)" }}>Responsible Agency :</b>
      <br />
      {initialValues?.aiAnalysis?.request_type
        ? capitalizeFirstLetter(initialValues?.aiAnalysis?.responsible_agency)
        : "No responsible agency available"}
    </p>


  </div>
</div>


                <div className="mt-2">
                  {loading && (
                    <div className="col mt-3">
                      <div style={{ textAlign: "center", marginTop: "50px" }}>
                        <RingLoader
                          loading={loading}
                          size={100} // sets both height & width (in px)
                          color="#36d7b7" // any HEX or color string
                          cssOverride={{
                            display: "block",
                            margin: "0 auto", // center it
                            borderColor: "red", // optional, not necessary for RingLoader
                          }}
                        />
                        <p style={{ fontSize: "18px", marginBottom: "15px" }}>
                          Analysis Image, please wait...
                        </p>
                      </div>
                    </div>
                  )}
                  {!loading &&
                    initialValues.aiImageAnalysis?.length > 0 &&
                    initialValues.aiImageAnalysis.map((res, index) => (
                      <div className="col mt-3" key={index}>
                        <div className="row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
                          <div className="col p-3 d-flex flex-column position-static">
                            <div className="col-md-12">
                              <i className="fa-solid fa-magnifying-glass-plus"></i>
                              <b style={{ marginLeft: "4px" }}>
                                Image analysis of AI image :
                              </b>
                              <div className="mt-2">
                                <p>
                                  <b style={{ color: "rgb(15, 255, 193)" }}>
                                    Issue description:
                                  </b>{" "}
                                  {res?.classification?.issue_description}
                                </p>
                                <p>
                                  <b style={{ color: "rgb(15, 255, 193)" }}>
                                    Category:
                                  </b>{" "}
                                  {
                                    res?.classification
                                      ?.classification_labels[0]?.label
                                  }
                                </p>
                                <p>
                                  <b style={{ color: "rgb(15, 255, 193)" }}>
                                    Accuracy:{" "}
                                  </b>{" "}
                                  {
                                    res?.classification
                                      ?.classification_labels[0]?.confidence
                                  }
                                  %
                                </p>

                              </div>
                            </div>
                          </div>
                          <div className="col-auto d-none d-lg-block">
                            <img
                              src={res?.image_path}
                              alt="Thumbnail"
                              style={{
                                width: "200px",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                 <div className="mt-2">
                  {loading && (
                    <div className="col mt-3">
                      <div style={{ textAlign: "center", marginTop: "50px" }}>
                        <RingLoader
                          loading={loading}
                          size={100} // sets both height & width (in px)
                          color="#36d7b7" // any HEX or color string
                          cssOverride={{
                            display: "block",
                            margin: "0 auto", // center it
                            borderColor: "red", // optional, not necessary for RingLoader
                          }}
                        />
                        <p style={{ fontSize: "18px", marginBottom: "15px" }}>
                          Analysis Image, please wait...
                        </p>
                      </div>
                    </div>
                  )}
                  {!loading &&
                    initialValues.aiImageAnalysis?.length > 0 &&
                    initialValues.aiImageAnalysis.map((res, index) => (
                      <div className="col mt-3" key={index}>
                        <div className="row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
                          <div className="col p-3 d-flex flex-column position-static">
                            <div className="col-md-12">
                            <i className="fa-solid fa-clock mr-1" style={{marginRight:'2%'}}></i>
                              <b style={{ marginLeft: "4px" }}>
                                Estimated Resolution :
                              </b>
                              <div className="mt-2">
                                <p style={{fontSize:'1.2rem'}}>
                                <i className="fa-solid fa-clock mr-1" style={{marginRight:'2%'}}></i>
                                  <b style={{ color: "rgb(15, 255, 193)" }}>
                                   Predicted Time:
                                  </b>{" "}
                                   {
                                    initialValues?.aiPredictedTime?.predicted_resolution_time_days
                                    ? getRoundOfValue(initialValues?.aiPredictedTime?.predicted_resolution_time_days)
                                    : "No responsible agency available"
                                  } { typeof(getRoundOfValue(initialValues?.aiPredictedTime?.predicted_resolution_time_days)) === 'number' ? 'business days' : '' }
                                </p>
                                <p style={{fontSize:'1.2rem'}} >
                                <i className="fa-solid fa-tachometer-alt mr-1" style={{marginRight:'2%'}}></i>
                                  <b style={{ color: "rgb(15, 255, 193)" }}>
                                  Confidence:
                                  </b>{" "}
                                  {
                                    'Medium'
                                  }
                                </p>

                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    ))}
                </div>
              </div>
              {/* <div className="mt-1 text-light">
                <div className="border border-white p-3 rounded shadow-sm">
                  <p style={{ fontSize: '14px' }}>Report Summary</p>
                  <p style={{ fontSize: '14px' }}>There is debris and trash dumped on the street</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* <div className="row">
          <div className="col-md-6 col-lg-6 ">
            <div
              className="card card-size "
              style={{ background: "rgb(31, 41, 53)" }}
            >
              {" "}
              <div className="heading-content p-1">
                <h5>Logs History</h5>
              </div>
              <Steps
                className="logs "
                progressDot
                direction="vertical"
                items={logList}
              />
            </div>
          </div>
        </div> */}
      </div>

      <div
        className="container-fluid "
        id="download-template"
        style={{
          display: isDivVisible ? "block" : "none", // Toggle visibility based on state
        }}
      >
        <div
          className="pt-3 pb-2 card-margin"
          style={{
            textAlign: "right",
          }}
        ></div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-size1 status-card-download">
              <div className="heading-content p-1">
                <h5>Ticket Status</h5>
              </div>

              <div className="p-5 ">
                <Steps
                  className="download"
                  current={currentStepIndex}
                  items={steps.map((step, index) => ({
                    ...step,
                    status:
                      index < currentStepIndex
                        ? "finish" // Completed steps
                        : index === currentStepIndex
                        ? currentStepIndex === steps.length - 1
                          ? "finish" // Last step should be "finish" instead of "process"
                          : "process" // Current step in progress
                        : "wait", // Future steps
                  }))}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-lg-12">
            <div className="card card-size-download">
              <Formik
                // validationSchema={validationSchema}
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={(values, { resetForm }) => {
                  submit(values, resetForm); // Use your custom submit logic here
                }}
              >
                {({ errors, touched, setFieldValue }) => (
                  <Form id="signup-form" className="signup-form">
                    <div className="row">
                      <div className="heading-content p-1">
                        <h5>Tickets Detail</h5>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">
                          Ticket Number
                        </label>
                        <div className="mt-1"> {data.ticketNumber}</div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">
                          Ticket Type
                        </label>
                        <div className="mt-1"> {data.request_type}</div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">
                          Ticket Sub Type
                        </label>
                        <div className="mt-1"> {data.request_subtype}</div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">
                          Priority
                        </label>
                        <div className="mt-1"> {data.priority}</div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">Status</label>
                        <div className="mt-1">
                          {" "}
                          {data.status == "Request Created"
                            ? "Reported"
                            : data.status}
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-4"></div>
                    </div>

                    <div className="row mt-3">
                      <div className="heading-content p-1">
                        <h5>Reporter Details</h5>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">Name</label>
                        <div className="mt-1">
                          {" "}
                          {data?.name ? data?.name : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">
                          Phone No
                        </label>
                        <div className="mt-1">
                          {" "}
                          {data?.contact_phone ? data?.contact_phone : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <label className="label-heading-download">
                          Contact Email
                        </label>
                        <div className="mt-1">
                          {" "}
                          {data?.contactEmail ? data?.contactEmail : "N/A"}
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="form-group">
                        <div className="col-md-6 col-lg-6">
                          <label className="label-heading-download">
                            Description
                          </label>
                          <div className="mt-1"> {data.description}</div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="form-group">
                        <div className="col-md-6 col-lg-6">
                          <label className="label-heading-download">
                            Address
                          </label>
                          <div className="mt-1"> {data.description}</div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    ></div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <Modal
  open={confirmLogsModal}
  onCancel={cancelToggleLogs}
  destroyOnClose={true}
  footer={null}
  maskClosable={false}
>
  <div className="signup-content-model1">
    <h5 style={{ marginBottom: "10px", fontWeight: 600, fontSize: "18px" }}>
      📝 Comments History
    </h5>

    {/* Scrollable container */}
    <div
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        padding: "10px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "1px solid #dee2e6",
      }}
    >
      {data.comment?.length > 0 ? (
        data.comment.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              marginBottom: "15px",
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              padding: "10px",
              alignItems: "flex-start",
            }}
          >
            {/* Avatar / Initials */}
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#007bff",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "14px",
                marginRight: "10px",
              }}
            >
              {item.author?.charAt(0).toUpperCase()}
            </div>

            {/* Comment Body */}
            <div>
              <p style={{ margin: 0, fontWeight: "600", color: "#343a40" }}>
                {item.author}
              </p>
              <p style={{ margin: "5px 0 0", color: "#495057" }}>
                {item.description}
              </p>
            </div>
          </div>
        ))
      ) : (
        <p style={{ color: "#888", textAlign: "center" }}>No comments available</p>
      )}
    </div>

    <div className="submit-container1" style={{ marginTop: "20px", textAlign: "right" }}>
      <button
        className="submit-button2"
        type="button"
        onClick={cancelToggleLogs}
        style={{
          backgroundColor: "#dc3545",
          color: "#fff",
          border: "none",
          padding: "8px 16px",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Close
      </button>
    </div>
  </div>
</Modal>


    </>
  );
}
